module.exports = __webpack_public_path__ + "static/media/CERTIFYING1.bd630465.png";